import React from 'react';
import { Eyebrow } from './ui/Eyebrow';
import { testimonials } from '../data/content';
export function TestimonialsSection() {
  const [featured, ...rest] = testimonials;
  return <section className="border-b border-line bg-sand" data-id="element-241" data-mp="1n00ra3zw93vo">
      <div className="mx-auto max-w-6xl px-5 py-20 lg:py-24" data-id="element-242" data-mp="1mziu955eqlmp">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between" data-id="element-243" data-mp="1r146coa4avvu">
          <div data-id="element-244" data-mp="1d1bh6xe8onpz">
            <Eyebrow data-id="element-245" data-mp="1d1l4uebtaisi">La eligen profes de guitarra</Eyebrow>
            <h2 className="mt-4 font-condensed text-4xl uppercase leading-[0.95] tracking-tight text-ink sm:text-5xl" data-id="element-246" data-mp="1d47bmbqvou9o">
              Lo que dicen los profes
            </h2>
          </div>
          <p className="text-[13px] text-ink-mute" data-id="element-247" data-mp="143961p0skeoz">
            Estudios, academias y profesores particulares
          </p>
        </div>

        <div className="mt-12 grid gap-6 lg:grid-cols-2" data-id="element-248" data-mp="2yenwk81mmi5s">
          <figure className="flex h-full flex-col overflow-hidden rounded-2xl border border-line bg-paper shadow-card" data-id="element-249" data-mp="2yd37uz1zttfu">
            {featured.photo && <img src={featured.photo} alt={`${featured.name}, ${featured.role}`} className="h-64 w-full object-cover object-top sm:h-72" loading="lazy" data-id="element-250" data-mp="2v12pb9u3wzfe" />}
            <div className="flex flex-1 flex-col p-8 sm:p-10" data-id="element-251" data-mp="2q0ewcimbi8ij">
              <blockquote className="font-display text-2xl italic leading-snug text-ink sm:text-[26px]" data-id="element-252" data-mp="34q2n4pwvhos0">
                “{featured.quote}”
              </blockquote>
              <figcaption className="mt-auto flex items-center gap-4 pt-8" data-id="element-253" data-mp="2c2gnttuoh6ay">
                <span aria-hidden="true" className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-ink text-sm font-semibold text-cream" data-id="element-254" data-mp="2c4jiir6rznm0">
                  {featured.initials}
                </span>
                <span data-id="element-255" data-mp="2h22wrr3h40dy">
                  <span className="block text-sm font-semibold text-ink" data-id="element-256" data-mp="2h0rtrthuqwnw">{featured.name}</span>
                  <span className="block text-[13px] text-ink-mute" data-id="element-257" data-mp="19vsta0cl3vw">{featured.role}</span>
                </span>
              </figcaption>
            </div>
          </figure>

          <ul className="grid gap-4" data-id="element-258" data-mp="3f0v9mpdo0x0">
            {rest.map(item => <li key={item.name} className="flex flex-col rounded-xl border border-line bg-paper px-6 py-5" data-id="element-259" data-mp="3eiqu2skage0">
                <blockquote className="text-[15px] leading-relaxed text-ink-soft" data-id="element-260" data-mp="8fydfzae0uyi">
                  “{item.quote}”
                </blockquote>
                <div className="mt-auto flex items-center gap-3 pt-4" data-id="element-261" data-mp="ickt89nuwvto">
                  {item.photo ? <img src={item.photo} alt={`${item.name}, ${item.role}`} className="h-10 w-10 shrink-0 rounded-full object-cover object-top" loading="lazy" data-id="element-262" data-mp="3gtx88xlmiaaf" /> : <span aria-hidden="true" className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-sand text-[11px] font-semibold text-ink-soft" data-id="element-263" data-mp="3lt9srbp0v59u">
                      {item.initials}
                    </span>}
                  <span className="text-[13px] text-ink" data-id="element-264" data-mp="3vkeagj63148d">
                    <span className="font-semibold" data-id="element-265" data-mp="2y2e60szfb09g">{item.name}</span>
                    <span className="text-ink-mute" data-id="element-266" data-mp="331qufi5y0fe5"> · {item.role}</span>
                  </span>
                </div>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}